import { Component, OnInit, ViewChild } from "@angular/core";
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from "primeng/dynamicdialog";
import { GroupActionService } from "../../shared/group-action.service";
import {
	wsGroupActionAdvancedIncidentCalendarDataParm,
	wsGroupActionAdvancedIncidentCalendarDataInfo,
	wsGroupActionAdvancedIncidentAddUpdateComment,
	wsGroupActionAdvancedIncidentAddUpdateInfraction,
	wsGroupActionAdvancedIncidentAddUpdatePenalty,
	wsGroupActionAdvancedIncidentAddUpdateParm,
} from "../../shared/GroupActionAdvanced";
import { wsGroupActionBasicIncidentAddUpdateParm } from "../../shared/GroupActionBasic";
import { UpdateOldPromptComponent } from "../sgedit-release/update-old-prompt/update-old-prompt.component";
import { SGEditAdvancedComponent } from "./sgedit-advanced/sgedit-advanced.component";
import { SGEditBasicComponent } from "./sgedit-basic/sgedit-basic.component";

@Component({
	selector: "app-sgedit-incident",
	templateUrl: "./sgedit-incident.component.html",
	styleUrls: ["./sgedit-incident.component.css"],
})
export class SGEditIncidentComponent implements OnInit {
	constructor(
		public ref: DynamicDialogRef,
		private dialogConfig: DynamicDialogConfig,
		private dataService: GroupActionService,
		private dialogService: DialogService
	) {}

	ngOnInit(): void {
		//Load data from parent
		this.GroupActionID = this.dialogConfig.data.GroupActionID;

		this.user = this.dialogConfig.data.user;
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.SelectedGroup = this.dialogConfig.data.SelectedGroup;

		this.GroupName = this.SelectedGroup.GroupName;

		this.loadAdvancedModePref();
	}

	//////////////////////////////////////
	// Data
	//////////////////////////////////////

	GroupActionID: any;

	EnableAdvancedMode: any = false;

	popup_Width = (window.innerWidth - 100).toString() + "px";
	// popup_Width = (window.innerWidth - 80).toString() + "px";

	user: any;
	SchoolID: any;
	SelectedGroup: any;

	IncidentOption: any = "Basic";

	GroupName: any = "";

	@ViewChild(SGEditBasicComponent)
	BasicRef: SGEditBasicComponent;

	@ViewChild(SGEditAdvancedComponent)
	AdvancedRef: SGEditAdvancedComponent;

	//////////////////////////////////////

	//////////////////////////////////////
	// Load Data
	//////////////////////////////////////
	loadAdvancedModePref() {
		var result = this.dataService.GroupActionAdvanceModeEnabled();
		result.subscribe(
			(response) => {
				this.EnableAdvancedMode = response;

				if (this.EnableAdvancedMode == true) {
					this.IncidentOption = "Advanced";
				}
			},
			(error) => {}
		);
	}
	//////////////////////////////////////

	//////////////////////////////////////
	// Buttons
	//////////////////////////////////////
	onEdit() {
		//Call method based on mode
		if (this.IncidentOption == "Basic") {
			this.EditBasic();
		} else if (this.IncidentOption == "Advanced") {
			this.EditAdvanced();
		}
	}

	EditBasic() {
		//
		//	Validate
		//
		if (this.BasicRef.isConfigError == true) {
			return;
		} else {
			this.BasicRef.ErrorMessage = "";
		}

		if (this.BasicRef.rIncidentDT != null) {
			if (this.BasicRef.rIncidentDT.getFullYear() < 1753) {
				// SQL Does not support dates < 1753
				this.BasicRef.ErrorMessage = "Invalid Discipline Date. Date must be greater then 1/1/1753.";
				return;
			}
		} else {
			this.BasicRef.ErrorMessage = "Invalid Discipline Date.";
			return;
		}

		if (this.BasicRef.SelectedInfraction.InfractionID < 1) {
			this.BasicRef.ErrorMessage = "Invalid Infraction.";
			return;
		}

		if (this.BasicRef.SelectedPenalty.PenaltyID < 1) {
			this.BasicRef.ErrorMessage = "Invalid Action.";
			return;
		}

		//Update Old
		var ref = this.dialogService.open(UpdateOldPromptComponent, {
			header: "Update Incident",
			width: "fit-content",
			data: {},
		});
		ref.onClose.subscribe((response) => {
			if (response != -1) {
				this.FinishBasicEdit(response);
			}
		});
	}

	FinishBasicEdit(UpdateOld) {
		//
		//	Validate Passed / Do the Update
		//
		var parmIsUseDayCount: boolean = false;
		var parmSuspNbrDays: number = 0;
		var parmStartDate: Date = null;
		var parmEndDate: Date = null;

		if (this.BasicRef.risSusp == true) {
			if (this.BasicRef.selectedRadioValue == "1") {
				parmIsUseDayCount = false;
				parmSuspNbrDays = this.BasicRef.rSuspNbrDays1;
				parmStartDate = this.BasicRef.rStartDate1;
				parmEndDate = this.BasicRef.rEndDate1;
			} else {
				parmIsUseDayCount = true;
				parmSuspNbrDays = this.BasicRef.rSuspNbrDays2;
				parmStartDate = this.BasicRef.rStartDate2;
				parmEndDate = this.BasicRef.rEndDate2;
			}
		}

		//
		//	Convert From GMT DateTime to Local DateTime
		//
		let strIncidentDT = new Date(this.BasicRef.rIncidentDT).toLocaleString("en-US");
		let strStartDate = new Date(parmStartDate).toLocaleString("en-US");
		let strEndDate = new Date(parmEndDate).toLocaleString("en-US");

		let parm: wsGroupActionBasicIncidentAddUpdateParm = {
			Administrator_PersonID: this.user.personID,
			GroupID: this.SelectedGroup.GroupID,
			GroupActionID: this.GroupActionID,
			IncidentDT: strIncidentDT,
			InfractionID: this.BasicRef.SelectedInfraction.InfractionID,
			PenaltyID: this.BasicRef.SelectedPenalty.PenaltyID,
			ContinueAlert: this.BasicRef.rContinueAlert,
			isSusp: this.BasicRef.risSusp,
			IsUseDayCount: parmIsUseDayCount,
			SuspNbrDays: parmSuspNbrDays,
			StartDate: strStartDate,
			EndDate: strEndDate,
			ParentPortalSendNotification: this.BasicRef.ParentPortalSendNotification,
			StudentPortalSendNotification: this.BasicRef.StudentPortalSendNotification,
			StaffPortalSendNotification: this.BasicRef.StaffPortalSendNotification,
			PromptTypeID: this.BasicRef.SelectedPromptTypeID,
			UpdateOld: UpdateOld,
		};

		this.BasicRef.isBusy = true;

		this.dataService.GroupActionBasicIncidentUpdate(parm).subscribe((data) => this.BasicRef.DisciplineBasicIncidentAdd_Complete(data));
	}

	EditAdvanced() {
		this.AdvancedRef.ErrorMessage = "";

		if (this.AdvancedRef.lstAssignedInfractionItems.length == 0 || this.AdvancedRef.lstAssignedPenaltyItems.length == 0) {
			this.AdvancedRef.ErrorMessage = "At least one Infraction and one Action must be assigned.";
			return;
		}

		var HasPrimaryInfraction: boolean = false;
		var HasPrimaryAction: boolean = false;

		this.AdvancedRef.lstAssignedInfractionItems.forEach((item) => {
			if (item.isPrimary == true) {
				HasPrimaryInfraction = true;
			}
		});

		this.AdvancedRef.lstAssignedPenaltyItems.forEach((item) => {
			if (item.isPrimary == true) {
				HasPrimaryAction = true;
			}
		});

		if (HasPrimaryInfraction == false || HasPrimaryAction == false) {
			this.AdvancedRef.ErrorMessage = "At least one Infraction and one Action must be set to Primary.";
			return;
		}

		// Suspension Not Primary Check
		this.AdvancedRef.lstAssignedPenaltyItems.forEach((item) => {
			if (item.isSusp == true && item.isPrimary == false) {
				this.AdvancedRef.ErrorMessage = "The assigned Action '" + item.PenaltyCD + "' is a suspenstion and must be set to Primary.";
				return;
			}
		});

		//
		//	Validate Incident Date / Time
		//
		if (this.AdvancedRef.rIncidentDT != null) {
			if (this.AdvancedRef.rIncidentDT.getFullYear() < 1753) {
				// SQL Does not support dates < 1753
				this.AdvancedRef.ErrorMessage = "Invalid Discipline Date. Date must be greater then 1/1/1753.";
				return;
			}
		} else {
			this.AdvancedRef.ErrorMessage = "Invalid Discipline Date.";
			return;
		}

		//
		//	IF Has SUSP! and selectedRadioValue = 1
		//
		if (this.AdvancedRef.rHasSusp == true && this.AdvancedRef.selectedRadioValue == "1") {
			if (this.AdvancedRef.rStartDate1 != null) {
				if (this.AdvancedRef.rStartDate1.getFullYear() < 1753) {
					// SQL Does not support dates < 1753
					this.AdvancedRef.ErrorMessage = "Invalid Start Date. Date must be greater then 1/1/1753.";
					return;
				}
			}

			if (this.AdvancedRef.rEndDate1 != null) {
				if (this.AdvancedRef.rEndDate1.getFullYear() < 1753) {
					// SQL Does not support dates < 1753
					this.AdvancedRef.ErrorMessage = "Invalid End Date. Date must be greater then 1/1/1753.";
					return;
				}
			}

			if (this.AdvancedRef.rStartDate1 > this.AdvancedRef.rEndDate1) {
				this.AdvancedRef.ErrorMessage = "Start Date cannot be greater than End Date";
				return;
			}

			let parm: wsGroupActionAdvancedIncidentCalendarDataParm = {
				SchoolID: this.SchoolID,
				StartDate: this.AdvancedRef.rStartDate1,
				EndDate: this.AdvancedRef.rEndDate1,
				IsUseDayCount: false,
				DayCount: -1,
			};

			this.AdvancedRef.isBusy = true;
			this.dataService
				.GroupActionAdvancedIncidentGetCalendarData(parm)
				.subscribe((data) => this.GroupActionAdvancedIncidentGetCalendarDataForUpdate_Complete(data));
		}

		//
		//	IF Has SUSP! and selectedRadioValue = 2
		//
		if (this.AdvancedRef.rHasSusp == true && this.AdvancedRef.selectedRadioValue == "2") {
			if (isNaN(Number(this.AdvancedRef.rSuspNbrDays2))) {
				this.AdvancedRef.ErrorMessage = "Number of days is not a number.";
				return;
			}

			if (Number(this.AdvancedRef.rSuspNbrDays2 < 1)) {
				this.AdvancedRef.ErrorMessage = "Number of days must be greater than 0.";
				return;
			}

			if (this.AdvancedRef.rSuspNbrDays2 < this.AdvancedRef.rMinDurationDayCount) {
				this.AdvancedRef.ErrorMessage = "Suspension Days cannot be less than " + this.AdvancedRef.rMinDurationDayCount.toString() + ".";
				return;
			}

			if (this.AdvancedRef.rSuspNbrDays2 > this.AdvancedRef.rMaxDurationDayCount) {
				this.AdvancedRef.ErrorMessage = "Suspension Days cannot be greater than " + this.AdvancedRef.rMaxDurationDayCount.toString() + ".";
				return;
			}

			if (this.AdvancedRef.rStartDate2 != null) {
				if (this.AdvancedRef.rStartDate2.getFullYear() < 1753) {
					// SQL Does not support dates < 1753
					this.AdvancedRef.ErrorMessage = "Invalid Start Date. Date must be greater then 1/1/1753.";
					return;
				}
			}

			let parm: wsGroupActionAdvancedIncidentCalendarDataParm = {
				SchoolID: this.SchoolID,
				StartDate: this.AdvancedRef.rStartDate2,
				EndDate: null,
				IsUseDayCount: true,
				DayCount: this.AdvancedRef.rSuspNbrDays2,
			};

			this.AdvancedRef.isBusy = true;
			this.dataService
				.GroupActionAdvancedIncidentGetCalendarData(parm)
				.subscribe((data) => this.GroupActionAdvancedIncidentGetCalendarDataForUpdate_Complete(data));
		}

		//
		//	IF Has no SUSP!
		//
		if (this.AdvancedRef.rHasSusp == false) {
			var ref = this.dialogService.open(UpdateOldPromptComponent, {
				header: "Update Incident",
				width: "fit-content",
				data: {},
			});
			ref.onClose.subscribe((response) => {
				if (response != -1) {
					this.onProcessAddUpdate(response);
				}
			});
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	DisciplineAdvancedIncidentGetCalendarDataForUpdate_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	GroupActionAdvancedIncidentGetCalendarDataForUpdate_Complete(data: any) {
		var CalendarData: wsGroupActionAdvancedIncidentCalendarDataInfo;

		CalendarData = data;

		if (CalendarData.IsUseDayCount == true) {
			this.AdvancedRef.rEndDate2 = new Date(CalendarData.SuspEndDate); // Must do new for this to work
		} else {
			this.AdvancedRef.rSuspNbrDays1 = CalendarData.SuspNbrDays;

			if (this.AdvancedRef.rSuspNbrDays1 < this.AdvancedRef.rMinDurationDayCount) {
				this.AdvancedRef.ErrorMessage = "Suspension Days cannot be less than " + this.AdvancedRef.rMinDurationDayCount.toString() + ".";
			}

			if (this.AdvancedRef.rSuspNbrDays1 > this.AdvancedRef.rMaxDurationDayCount) {
				this.AdvancedRef.ErrorMessage = "Suspension Days cannot be greater than " + this.AdvancedRef.rMaxDurationDayCount.toString() + ".";
			}
		}

		if (CalendarData.isCalendarValid == false) {
			this.AdvancedRef.ErrorMessage = "Open calendar days does not support Suspension Days. First update school calendar.";
		}

		this.AdvancedRef.isBusy = false;

		if (this.AdvancedRef.ErrorMessage.length == 0) {
			var ref = this.dialogService.open(UpdateOldPromptComponent, {
				header: "Update Incident",
				width: "fit-content",
				data: {},
			});
			ref.onClose.subscribe((response) => {
				if (response != -1) {
					this.onProcessAddUpdate(response);
				}
			});
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onProcessAddUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	onProcessAddUpdate(UpdateOld) {
		//
		//	All Validations Passed. Do the Add / Update
		//
		var parmIsUseDayCount: boolean = false;
		var parmSuspNbrDays: number = 0;
		var parmStartDate: Date = null;
		var parmEndDate: Date = null;

		if (this.AdvancedRef.rHasSusp == true) {
			if (this.AdvancedRef.selectedRadioValue == "1") {
				parmIsUseDayCount = false;
				parmSuspNbrDays = this.AdvancedRef.rSuspNbrDays1;
				parmStartDate = this.AdvancedRef.rStartDate1;
				parmEndDate = this.AdvancedRef.rEndDate1;
			} else {
				parmIsUseDayCount = true;
				parmSuspNbrDays = this.AdvancedRef.rSuspNbrDays2;
				parmStartDate = this.AdvancedRef.rStartDate2;
				parmEndDate = this.AdvancedRef.rEndDate2;
			}
		}

		// Build Comment List
		let lstAddUpdateCommentItems: wsGroupActionAdvancedIncidentAddUpdateComment[] = [];

		this.AdvancedRef.lstCommentItems.forEach((item) => {
			//	Convert From GMT DateTime to Local DateTime
			let str_c_date = new Date(item.c_date).toLocaleString("en-US");

			lstAddUpdateCommentItems.push({
				IncidentImageID: item.IncidentImageID,
				c_date: str_c_date,
				IncidentImageTitle: item.IncidentImageTitle,
				IncidentImageComment: item.IncidentImageComment,
			});
		});

		// Build Penality List
		let lstAddUpdateInfractionItems: wsGroupActionAdvancedIncidentAddUpdateInfraction[] = [];

		this.AdvancedRef.lstAssignedInfractionItems.forEach((item) => {
			lstAddUpdateInfractionItems.push({
				InfractionID: item.InfractionID,
				isPrimary: item.isPrimary,
			});
		});

		// Build Penality List
		let lstAddUpdatePenaltyItems: wsGroupActionAdvancedIncidentAddUpdatePenalty[] = [];

		this.AdvancedRef.lstAssignedPenaltyItems.forEach((item) => {
			lstAddUpdatePenaltyItems.push({
				PenaltyID: item.PenaltyID,
				isPrimary: item.isPrimary,
			});
		});

		//
		//	Build Main Parm For Add / Update
		//
		if (this.AdvancedRef.isAdd == true) {
			//
			//	Convert From GMT DateTime to Local DateTime
			//
			let strIncidentDT = new Date(this.AdvancedRef.rIncidentDT).toLocaleString("en-US");
			let strStartDate = new Date(parmStartDate).toLocaleString("en-US");
			let strEndDate = new Date(parmEndDate).toLocaleString("en-US");

			let parm: wsGroupActionAdvancedIncidentAddUpdateParm = {
				GroupID: this.SelectedGroup.GroupID,
				GroupActionID: this.GroupActionID,
				UpdateOld: UpdateOld,
				Administrator_PersonID: this.user.personID,
				AddStudentPrompt: this.AdvancedRef.SelectedPromptTypeID,
				IncidentDT: strIncidentDT,
				FacilityLocationID: this.AdvancedRef.SelectedFacilityLocation.FacilityLocationID,
				ContinueAlert: this.AdvancedRef.rContinueAlert,
				HasSusp: this.AdvancedRef.rHasSusp,
				IsUseDayCount: parmIsUseDayCount,
				SuspNbrDays: parmSuspNbrDays,
				StartDate: strStartDate,
				EndDate: strEndDate,
				ParentPortalSendNotification: this.AdvancedRef.ParentPortalSendNotification,
				StudentPortalSendNotification: this.AdvancedRef.StudentPortalSendNotification,
				StaffPortalSendNotification: this.AdvancedRef.StaffPortalSendNotification,
				CommentItems: lstAddUpdateCommentItems,
				AssignedInfractionItems: lstAddUpdateInfractionItems,
				AssignedPenaltyItems: lstAddUpdatePenaltyItems,
			};

			this.AdvancedRef.isBusy = true;
			this.dataService.GroupActionAdvancedIncidentUpdate(parm).subscribe((data) => this.AdvancedRef.GroupActionAdvancedIncidentAdd_Complete(data));
		}
	}

	onClose() {
		this.ref.close(0);
	}

	//////////////////////////////////////
}
